import { Button } from "antd";

export const CreateGLAccountButton = ({
  text,
  onClick,
  disabled,
  inverseColors,
}: {
  text: string;
  onClick: () => void;
  disabled: boolean;
  inverseColors?: boolean;
}) => {
  const bgColor = inverseColors ? "#FFFFFF" : "#212430";
  const textColor = inverseColors ? "text-black" : "text-white";
  const hoverBgColor = inverseColors ? "#d3d3d3" : "#020211";
  const hoverTextColor = inverseColors ? "#212430" : "#fff";
  const hoverBorderColor = inverseColors ? "#FFFFFF" : "#020211";

  return (
    <div className="flex flex-column justify-center">
      <Button
        className={` 
        flex 
        justify-center 
        items-center 
        py-4 sm:py-5 
        mt-2
        rounded-md 
        ${textColor}
        font-medium
        bg-[${bgColor}] 
        hover:bg-[${hoverBgColor}] hover:text-[${hoverTextColor}] hover:border-[${hoverBorderColor}]
      `}
        style={{ width: 315 }}
        block
        disabled={disabled}
        onClick={onClick}>
        {text}
      </Button>
    </div>
  );
};
